<span class="badge badge-config-pedido-tipo-venda badge-config-pedido-tipo-venda-bonificacao"
    [title]="isAbreviacao ? tipo.nome : ''">
    {{isAbreviacao ? tipo.abreviacao : tipo.nome}}
</span>